// function initializeSliders() {
//      var IS_Applied = document.querySelector('.media_thubnails_wrapper.media_thubnails_slider.slick-initialized');
//   if(!IS_Applied){
//   $(".media_main_preview_slider").slick({
//     slidesToShow: 1,
//     autoplay: false,
//     infinite: false,
//     slidesToScroll: 1,
//     arrows: false,
//     // asNavFor: '.media_thubnails_slider'
//   });

//   $(".media_thubnails_slider").slick({
//     slidesToShow: 7,
//     slidesToScroll: 1,
//     infinite: false,
//     vertical: true,
//     verticalSwiping: true,
//     autoplay: false,
//     swipeToSlide: true,
//     focusOnSelect: true,
//     asNavFor: '.media_main_preview_slider',
//     prevArrow: `<button type='button' class='slick-prev pull-left slick_arrow_media'><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>`,
//     nextArrow: `<button type='button' class='slick-next pull-right slick_arrow_media'><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>`,
//     responsive: [
//       {
//         breakpoint: 749,
//         settings: {
//           vertical: false,
//           verticalSwiping: false,
//           slidesToShow: 5,
//           arrows:false
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           vertical: false,
//           verticalSwiping: false,
//           slidesToShow: 3,
//           arrows:false
//         }
//       }
//     ]
//   });
//   var $slider = $(".media_thubnails_slider");

//   if ($slider.length) {
//     var currentSlide;
//     var slidesCount;
//     var sliderCounter = document.createElement("div");
//     sliderCounter.classList.add("slider__counter");

//     var updateSliderCounter = function (slick) {
//       currentSlide = slick.slickCurrentSlide() + 1;
//       $(sliderCounter).text(currentSlide + " of " + slidesCount + " Images");
//     };

//     $slider.on("init", function (event, slick) {
//       slidesCount = $slider.attr("data-count"); // Set the slidesCount when slider is initialized
//       $slider.append(sliderCounter);
//       if (slidesCount > 5) {
//         updateSliderCounter(slick);
//       }
//     });
//       $slider.on("afterChange", function (event, slick, currentSlide) {
//         updateSliderCounter(slick);
//       });
//     $slider.slick();
//   }
// }
// }
// $(document).ready(function () {
//   initializeSliders();
// });

// =================ZoomBTN =======================
document.addEventListener("DOMContentLoaded", function () {
  var ZoomBtn = document.querySelectorAll(".zoom-image_btn");
  ZoomBtn.forEach((btn) => {
    btn.addEventListener("click", function () {
      var TagetElemet = document.querySelector(
        ".media_slide_singal.slick-current.slick-active"
      );
      var ViewBox = document.querySelector(".wrapper_larger_view_box");
      ViewBox.classList.remove("hidden");
      ViewBox.querySelector(".wrapper_media_large-image").innerHTML =
        TagetElemet.innerHTML;
      // console.log(TagetElemet)
    });
  });
  var FeatureBtn = document.querySelectorAll(".wrapper_features_block");
  FeatureBtn.forEach((btn) => {
    btn.addEventListener("click", function () {
      var TagetElemet = this.querySelector(
        ".modle_content_product_features"
      );
      var ViewBox = document.querySelector(".wrapper_features_view_box");
      ViewBox.classList.remove("hidden");
      ViewBox.querySelector(".wrapper_media__features-content").innerHTML =
        TagetElemet.innerHTML;
      // console.log(TagetElemet)
    });
  });
  var RotateBtn = document.querySelectorAll(".rotate-image_btn");
  let RotationValue = 0;
  if(RotateBtn){
  RotateBtn.forEach((btn) => {
    btn.addEventListener("click", function () {
      var Model = document.querySelector("#magic-360-block");
      var ModelOrigonal = document.querySelector("div:has(>.product_media_grid_wapper)");
      if (Model) {
        Model.classList.toggle('visible_media');
        ModelOrigonal.classList.toggle('hidden_media');
      } else {
        var TagetElemet = document.querySelector(".media_main_preview_wrapper .slick-current.slick-active");
        RotationValue += 90;
        TagetElemet.style.setProperty("--rotate", RotationValue + "deg");
      }
    });
  });
  }

  var ClosAllModals = document.querySelectorAll(".close_btn_modle");
  ClosAllModals.forEach((btn) => {
    btn.addEventListener("click", function () {
      var TagetElemet = this.closest(".target_modle_wrapper");
      TagetElemet.classList.add("hidden");
    });
  });
});
var VRBtn = document.querySelectorAll(".front-vr-image_btn");
if(VRBtn){
VRBtn.forEach((btn) => {
  btn.addEventListener("click", function () {
    const container = document.querySelector(
      ".media_slid_main_preview.media_slide_singal.slick-current.slick-active"
    );
    if (document.querySelector(".product_media_grid_wapper .vr_text_wrapper")) {
      document
        .querySelector(".product_media_grid_wapper .vr_text_wrapper")
        .remove();
    } else {
      const vrText = document.createElement("div");
      vrText.classList.add("vr_text_wrapper");
      vrText.innerText = "Front VR Text";
      container.appendChild(vrText);
    }
  });
});
}
document.addEventListener('DOMContentLoaded', function(){

// ========================Qty QTYselector ===================
function QTYSelector(){
var QTYselector = document.querySelectorAll(".icon_quantity_open");
  console.log('QTYselector' , QTYselector);
if (QTYselector) {
      QTYselector.forEach((selector) => {
      selector.addEventListener("click", function () {
        event.preventDefault();
        event.stopPropagation();
        var thisParent = this.closest(".quantity_selector_dropdown");
        thisParent.querySelector("ul").classList.toggle("hidden");
      });
      selector.addEventListener("focusout", function () {
        var thisParent = this.closest(".quantity_selector_dropdown");
        thisParent.querySelector("ul").classList.add("hidden");
      });
    });
}
var QTYITems = document.querySelectorAll(".qty-item_count");
if (QTYITems) {
  QTYITems.forEach((Items) => {
    Items.addEventListener("click", function () {
      event.preventDefault();
      event.stopPropagation();
      var thiSParenet = this.closest(".product-form__quantity");
      thiSParenet.querySelector(".quantity__input").value =
        this.getAttribute("data-value");
      thiSParenet.querySelector(".quantity__input").setAttribute("value", this.getAttribute("data-value"));
      thiSParenet.querySelector("ul").classList.add("hidden");
    });
  });
}
}
  QTYSelector()
  document.body.addEventListener("click", function (event) {
  var dropdowns = document.querySelectorAll(".quantity_selector_dropdown ul");
  dropdowns.forEach((dropdown) => {
    if (!dropdown.classList.contains("hidden")) {
      dropdown.classList.add("hidden");
    }
  });
});
});